import {t} from "@lingui/core/macro";
import * as React from "react";

import ErrorLoading from "@khan/component-screens/error-loading";

import PageDisplay from "#data-access/page-display.tsx";

import DefaultPageTemplate from "../page-templates/default-page-template.tsx";

type Props = {
    resetSettings?: boolean;
};

/**
 * A full-page error message shown when we encounter an unexpected error.
 */
const ErrorLoadingPage = ({resetSettings}: Props): React.ReactElement => (
    <DefaultPageTemplate>
        <PageDisplay
            resetSettings={resetSettings}
            settings={{
                title: t`Oops. Something went wrong. Please try again.`,
                statusCode: 500,
            }}
        >
            <ErrorLoading />
        </PageDisplay>
    </DefaultPageTemplate>
);

export default ErrorLoadingPage;
